// Metti true per riattivare la dicitura rate + logo Klarna in tutto il sito
// (una volta che Klarna sarà abilitato sull'account Stripe).
export const KLARNA_ENABLED = false;
